<template>
	<div>
		<div style="display: flex;width: 100%;background-color: #0F0B26;">
			<div style="width: 30%;display: flex;align-items: center;justify-content: center;color: white;">
				<div>
					<div style="background-color: #00a8f8;padding: 10px 20px;">1小时内:</div>
					<div style="background-color: #d9001b;margin:20px 0;padding: 10px 20px;">1-6小时:</div>
					<div style="background-color: #fcb300;padding: 10px 20px;">6-12小时:</div>
				</div>
				
			</div>
			<div style="width: 70%;height: 350px;">
				<div id="tb33" style="height: 310px;"></div>
				<div style="height: 40px;color: white;text-align: center;font-size: 25px;">本月总停车时长</div>
			</div>
			 
		</div>
		<div style="margin-top: 20px;background-color: #0F0B26;color: white;">
			<div>设备警告信息</div>
			<div style="display: flex;justify-content: space-between;">
				<div>设备IP</div>
				<div>设备名称</div>
				<div>故障类型</div>
				<div>设备状态码</div>
				<div>故障/恢复时间</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	
		data() {
			return {

			}
		},
		mounted() {
			this.getJrqk()
		},
		methods: {
			getJrqk() {
				let myChart = this.echarts.init(document.getElementById('tb33'), 'dark');
				setTimeout(() => {
					this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {
						let data = [{
								value: res.data.data.undergraduate,
								name: "临时车位"
							},
							{
								value: res.data.data.master,
								name: "固定车位",
							},
						
						];
						let option = {
							backgroundColor: '#0F0B26',
							title: {
								text: '临停车'
							},
							tooltip: {
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c}"
							},
							color:['#00ffff', '#02a7f0'],
							legend: {
								x: 'right',
								y: 'top',
								data: ['固定车位', '临时车位']
							},
							series: [{
								name: '车位分布',
								type: 'pie',
								radius: '50%',
								data: data,
								avoidLabelOverlap: true, //图饼标签false重复
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},
								itemStyle: {
									normal: {
										label: {
											show: true,
											formatter: '{b} : {c} '
										},
										labelLine: {
											show: true
										}
									},
								}
							}]
						}
						myChart.setOption(option);
					})
				}, 100)
			}
		}
	}
</script>

<style scoped="scoped">
</style>
